<template>
  <div class="OrderList">
    <navigator title="订单列表" :routePath='"/personal/propertyList"'></navigator>
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="orderBox" v-for="(item, index) in tableData3" :key="index"  @click="details(item.orderType, item.orderId)">
        <p class="orderTitle">{{item.title}}</p>
        <p class="orderPrice">订单金额：{{item.approvalFee>0 ? (item.approvalFee/100) : (item.orderFee/100) | PriceFilter}}</p>
        <p class="orderStatus">{{item.orderStatus | orderStatusFilter(item.orderType)}}</p>
        <div class="orderDetalis">
          <p class="orderId">订单编号：{{item.orderId}}</p>
          <p class="orderTime">下单时间：{{item.createTime | DateFilter('yyyy-MM-dd hh:mm:ss')}}</p>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data(){
    return{
      serviceFlag: 0,
      tableData3:[],
      pageIndex: 1,
      msgtotal: 0,
      loading: false,
      finished: false,
    }
  },
  methods:{
    details(Ty, id) {
      this.$router.push({ path: `/personal/orderDetail`, query: { orderType: Ty, orderId: id } });
    },
    getlist() {
      if (this.serviceFlag === 9) {
        this.tableData3 = [];
        this.$http.post(`${this.URL_PREFIX}/app/get/user/shop/order/list`, {
          currPage: this.pageIndex,
          pageRows: 10,
        },{
          headers: { token: this.token },
        }).then((respon) => {
          const res = respon.data;
          if(res.resCode === '10000') {
            const tempArr = res.resData.pageList ? res.resData.pageList : [];
            this.tableData3 = this.tableData3.concat(tempArr);
            if(res.resData.pageInfo && res.resData.pageInfo.total) {
              this.msgtotal = res.resData.pageInfo.total;
            }
            this.finished = this.tableData3.length >= this.msgtotal ? true : false;
          }else{
            this.$toast(res.resDesc);
          }
          this.loading = false;
        });
      }else {
        const askBoby = {
          currPage: this.pageIndex,
          pageRows: 6,
        };
        if (this.serviceFlag) {
          askBoby.serviceFlag = this.serviceFlag;
        }
        this.$http.post(`${this.URL_PREFIX}/app/get/user/order/info/list`, askBoby,{
          headers: { token: this.token },
        }).then((respon) =>{
          const res = respon.data;
          if(res.resCode === '10000') {
            const tempArr = res.resData.pageList ? res.resData.pageList : [];
            this.tableData3 = this.tableData3.concat(tempArr);
            if(res.resData.pageInfo && res.resData.pageInfo.total) {
              this.msgtotal = res.resData.pageInfo.total;
            }
            this.finished = this.tableData3.length >= this.msgtotal ? true : false;
          }else{
            this.$toast(res.resDesc);
          }
          this.loading = false;
        });
      }
    },
    loadMore() {
      if (this.tableData3.length >= this.msgtotal) {
        return;
      }
      console.log(this.tableData3.length);
      console.log(this.msgtotal);
      this.loading = true;
      this.pageIndex++;
      this.getlist();
    },
  },
  created() {
    this.serviceFlag = Number(this.$route.query.serviceFlag);
    this.getlist();
  },
  computed: {
    ...mapGetters(['currentParkId','token']),
  },
}
</script>
<style lang="scss" scoped>
.OrderList{
  .orderBox{
    margin-top: .133333rem;
    padding: .4rem .32rem;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    .orderTitle{
      font-size: .453333rem;
      font-weight: bold;
    }
    .orderPrice{
      margin-top: .266667rem;
      font-size: .4rem;
      font-weight: bold;
      color: rgb(217, 38, 44);
    }
    .orderStatus{
      margin-top: .266667rem;
      font-size: .4rem;
      font-weight: bold;
    }
    .orderDetalis{
      border-top: 1px solid rgb(245, 245, 245);
      margin-top: .4rem;
      .orderId{
        margin-top: .4rem;
        color: rgb(102, 102, 102);
      }
      .orderTime{
        color: rgb(102, 102, 102);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/OrderList.vue